import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, RouteReuseStrategy, withComponentInputBinding } from '@angular/router';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { authInterceptor } from 'angular-auth-oidc-client';
import { routes } from './app.routes';
import { accessErrorInterceptor } from '@core/auth/access-error.interceptor';
import { provideKeycloakAuth } from '@core/auth/auth.config';
import { DictionaryRouteReuseStrategy } from '@core/routing/dictionary-route-reuse-strategy';

export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        provideRouter(routes, withComponentInputBinding()),
        // Страница справочника одна: карточка открывается поверх списка, а не вместо него
        { provide: RouteReuseStrategy, useExisting: DictionaryRouteReuseStrategy },
        // authInterceptor подставляет Bearer-токен в запросы к environment.apiUrl (secureRoutes);
        // accessErrorInterceptor разбирает 403 с кодами доступа
        provideHttpClient(
            withFetch(),
            withInterceptors([authInterceptor(), accessErrorInterceptor]),
        ),
        provideKeycloakAuth(),
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
    ],
};
